// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3DioB","loaderOuter":"PageOverlayLoader_loaderOuter__1u8Q7"};